import { Link } from "react-router-dom";

const EconomicCalendarContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Information That Moves Markets</h2>
              <p>
                Economic indicators influence every market decision, from forex
                and commodities to stocks and crypto. With The Pips, you’ll
                never miss an opportunity driven by macroeconomic shifts. Our
                platform delivers timely updates on key releases, ensuring you
                understand how each event impacts market sentiment and price
                movements. You can easily compare forecasts with actual results
                to gauge potential volatility before it unfolds. Whether it's
                GDP announcements, inflation data, or employment reports, every
                detail is presented clearly and concisely. With this level of
                insight, you’re always equipped to make smart, strategic trading
                decisions.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                See Upcoming Events
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/economic_calendar/economic_calendar_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EconomicCalendarContentThree;
